import * as DialogPrimitive from '@radix-ui/react-dialog'
import { ShieldCheck, X } from 'lucide-react'
import { de } from '../i18n'
import { SidebarNav } from './SidebarNav'

export interface MobileNavProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function MobileNav({ open, onOpenChange }: MobileNavProps) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-[var(--c-overlay)] lg:hidden" />
        <DialogPrimitive.Content
          aria-label={de.app.name}
          className="fixed inset-y-0 left-0 z-50 flex w-72 max-w-[85vw] flex-col border-r border-rule bg-surface focus:outline-none lg:hidden"
        >
          <DialogPrimitive.Title className="sr-only">{de.app.name}</DialogPrimitive.Title>
          <div className="flex h-(--topbar-height) items-center gap-2 border-b border-rule px-4">
            <span aria-hidden className="flex size-6 items-center justify-center rounded-[var(--radius-control)] bg-accent-solid text-accent-solid-ink">
              <ShieldCheck className="size-3.5" />
            </span>
            <span className="flex-1 truncate text-base font-semibold tracking-tight text-ink">
              {de.app.name} <span className="font-normal text-ink-muted">{de.app.suiteName}</span>
            </span>
            <DialogPrimitive.Close
              aria-label={de.nav.closeMenu}
              className="rounded-[var(--radius-control)] p-1 text-ink-faint hover:bg-sunken hover:text-ink"
            >
              <X className="size-4" />
            </DialogPrimitive.Close>
          </div>

          <SidebarNav onNavigate={() => onOpenChange(false)} />
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  )
}
